import * as React from 'react';
import { Link } from 'react-router-dom';
import BasicPage from '../../components/BasicPage';
import { inject, observer } from 'mobx-react';
import { FormGroup, FormControl, Button } from 'react-bootstrap';

@inject('authStore', 'routing')
@observer
export default class Register extends React.Component<any> {
  handleNameChange = (e: any) => this.props.authStore.setName(e.target.value);
  handleEmailChange = (e: any) => this.props.authStore.setEmail(e.target.value);
  handlePhoneNumberChange = (e: any) => this.props.authStore.setPhoneNumber(e.target.value);
  handleUserNameChange = (e: any) => this.props.authStore.setUserName(e.target.value);
  handlePasswordChange = (e: any) => this.props.authStore.setPassword(e.target.value);
  
  handleSubmitForm = (e: any) => {
    e.preventDefault();
    this.props.authStore
      .register()
      .then(() => this.props.routing.history.replace('/login'));
  }

  render() {
    const { inProgress } = this.props.authStore;
    return (
      <BasicPage title="Sign up">
        <p>
          <Link to="login">Have an account?</Link>
        </p>

        <form onSubmit={this.handleSubmitForm}>
          <FormGroup>
            <FormControl
              type="text"
              placeholder="Name"
              onChange={this.handleNameChange}
              required
            />
          </FormGroup>
          <FormGroup>
            <FormControl
              type="text"
              placeholder="UserName"
              onChange={this.handleUserNameChange}
            />
          </FormGroup>
          <FormGroup>
            <FormControl
              type="password"
              placeholder="Password"
              onChange={this.handlePasswordChange}
            />
          </FormGroup>

          <FormGroup>
            <FormControl
              type="email"
              placeholder="abc@example.com"
              onChange={this.handleEmailChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <FormControl
              pattern="^\+?\d {10,15}$"
              placeholder="phone number (optional)"
              onChange={this.handlePhoneNumberChange}
            />
          </FormGroup>

          <Button
            bsSize="large"
            bsStyle="primary"
            type="submit"
            disabled={inProgress}
          >
            Sign up
          </Button>
        </form>
      </BasicPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/container/Account/Register.tsx